import { INDEXED_DB_INVALIDATION_TIMEOUT_MS, invalidateIndexedDBData } from "@/utils/indexeddb";
import { useEffect } from "react";

export const useIndexedDBInvalidation = () => {
  useEffect(() => {
    const invalidationInterval = setInterval(() => {
      invalidateIndexedDBData();
    }, INDEXED_DB_INVALIDATION_TIMEOUT_MS);
    return () => clearInterval(invalidationInterval);
  }, []);
};
